import { render, staticRenderFns } from "./learningCenter.vue?vue&type=template&id=cd84f582&"
import script from "./learningCenter.vue?vue&type=script&lang=js&"
export * from "./learningCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports